import {
  MAX_APPROVAL_TEMPLATE_DUE_DATE_OFFSET_DAYS,
  type ApprovalTemplate,
} from '../types/ApprovalTemplate';

/**
 * Converts an API template into the application model. The API retains retired
 * due-date/requester-note lock fields temporarily for rolling-deploy compatibility;
 * they must not enter application state.
 */
export const normalizeApprovalTemplate = (
  template: ApprovalTemplate | undefined
) => {
  if (!template) {
    return undefined;
  }

  return {
    ...template,
    ...(template.dueDateRule && {
      dueDateRule: {
        offset: Math.min(
          template.dueDateRule.offset,
          MAX_APPROVAL_TEMPLATE_DUE_DATE_OFFSET_DAYS
        ),
      },
    }),
    ...(template.requesterNote && {
      requesterNote: { value: template.requesterNote.value },
    }),
  };
};
